import { createApp } from 'vue'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'

import DailyCheckinModal from '../pages/DailyCheckinModal.vue'

// 掛載每日簽到 popup。初始狀態（由 HomeController 計算）以 data 屬性傳入，避免多一次 round-trip /
// popup 閃爍。autoOpen 為 true 時，若 status.show_popup 則自動彈出（首頁登入情境）。
class DailyCheckinModalComponent {
  constructor({ container }) {
    this.app = null
    this.container = container
  }

  init() {
    const el = document.querySelector(this.container)
    if (!el) return

    let initialStatus = null
    try {
      initialStatus = el.dataset.status ? JSON.parse(el.dataset.status) : null
    } catch (err) {
      console.error('Invalid daily check-in status payload:', err)
    }
    const autoOpen = el.dataset.autoOpen === 'true'

    this.app = createApp(DailyCheckinModal, { initialStatus, autoOpen })
    this.app.use(I18NextVue, { i18next })
    this.app.mount(this.container)
  }
}

export default DailyCheckinModalComponent
